import React from 'react'

const Content = () => {
  return (
    <div className='content glass-panel hacking-font'>
      <h1 className="hacking-green">Welcome to My Developer Portfolio</h1>
      <h3 className="hacking-green">Building Modern Web Applications and Creative Tools</h3>
      <p>
        This website showcases my journey as a passionate web developer. Here, you will find a collection of my projects, tools I have created for image, video, and PDF processing, and insights into my skills and expertise.
      </p>
      <p>
        I believe in blending creativity with technology to build digital experiences that are both functional and visually appealing. Feel free to explore my portfolio and discover the tools designed to make your workflow easier and more efficient.
      </p>
    </div>
  )
}

export default Content
